var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 218,
    height: 218,
    viewBox: "0 0 218 218",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M141.633 27.497C133.348 18.5513 121.775 13.625 109.001 13.625C96.1598 13.625 84.5487 18.5215 76.3013 27.4118C67.9645 36.4 63.9026 48.6157 64.8563 61.8064C66.7468 87.8301 86.5499 109 109.001 109C131.453 109 151.222 87.8344 153.142 61.8149C154.109 48.7434 150.021 36.5533 141.633 27.497Z",
    fill: "#4F6B7D",
    fillOpacity: 0.46
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M183.939 204.375H34.0638C32.1021 204.401 30.1594 203.988 28.3769 203.169C26.5945 202.349 25.0173 201.142 23.7599 199.636C20.9924 196.328 19.8768 191.81 20.7028 187.242C24.2964 167.306 35.5115 150.561 53.1388 138.805C68.7991 128.369 88.6362 122.625 109.001 122.625C129.366 122.625 149.204 128.373 164.864 138.805C182.491 150.556 193.706 167.302 197.3 187.237C198.126 191.806 197.01 196.323 194.243 199.632C192.986 201.139 191.409 202.346 189.626 203.167C187.844 203.987 185.901 204.4 183.939 204.375Z",
    fill: "#4F6B7D",
    fillOpacity: 0.46
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.23936094e0c1acfb0acca282f05638e5.svg";
export { ForwardRef as ReactComponent };